module.exports = __webpack_public_path__ + "media/images/web/landings/students/s2-2a7c665376c90b675128b48a4230ce1d.jpg";